<div class="layout-footer">
    <div class="footer-logo-container">
        <!--        <img [src]="'assets/layout/images/logo-' + logo + '.svg'" alt="diamond-layout"/>-->
        <a href="https://www.imzaflow.de" target="_blank" style="border:none;">
            <img [src]="'assets/images/sipo/logo-' + logo + '.svg'" alt="Imzaflow"/>
        </a>
        <!--<span class="footer-app-name">Imzaflow</span>-->
    </div>
    <span class="footer-copyright">&#169; {{ 'app.name' |translate: {name: appConfig.domain} }}</span>
</div>
